module.exports = __webpack_public_path__ + "img/政企@2x.876c2573.png";